<template>
  <tooltip
    :title="date"
    :delay="300"
  >
    {{ date | formatDateFromNow(this.noSuffix) || '–' }}
  </tooltip>
</template>

<script>
  import Tooltip from './tooltip'
  export default {
    components: {Tooltip},
    data: () => ({}),
    props: {
      date: {},
      noSuffix: {default: false},
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/date-from-now.vue